export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export const SERVER_DATE_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ssxxx";
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const TIMEZONE_INFO =
    'Пожалуйста, обратите внимание, что слоты для записи отображаются в соответствии с часовым поясом места оказания услуги';
export const TIMEZONE_GROUP_INFO =
    'Пожалуйста, обратите внимание, что время групповых событий отображается в соответствии с часовым поясом места оказания услуги';
